import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { required, minValue } from 'vuelidate/lib/validators';
import datePicker from '../../../components/forms/component.date-picker.vue';
import ageSwitch from '../../../components/forms/component.age-birthdate-input-switch.vue';
import { MainVueOpts } from '../../../main-vue';
import { ibSpinOpts } from '../../../helper-functions/applicationCommonValues';
import {
    isAfterField,
    convertDateByLang,
    monthDate,
    createDateByLangStr,
    createDateByLangApplications,
    numbersWithDashSlash,
    noAlphabets
} from '../../../helper-functions/helper-functions';
import {
    createUpdateApplicationService,
    checkExpiredAndTriggerValidation,
    uploadExchangeGuardAgeGroups,
    changeInSessionStorage,
    removeKeySessionStorage,
    goToFirstError,
    getItemSessionStorage
} from '../../../helper-functions/services';
import Step1Mixin from '../mixins/Step1Mixin';
import {
    WTPlanIds,
    hccConfig,
    requiredIfStudentPlans,
    requiredIfStudentPlansAndUSA,
    wtPlanIds
} from './shared';

Vue.use(Vuelidate);

export default {
    components:{
        'date-picker': datePicker,
        'age-switch': ageSwitch
    },
    props:['form-data'],
    mixins:[MainVueOpts, Step1Mixin],
    data: function(){
        return {
            studentSecurePlans: hccConfig.studentSecurePlans,
            travelerLimit: 10,
            formSending: false,
            showPrimaryValidation:false,
            showMobileError: false,
            showEndDateError: false,
            showHomeCountryQuestion: false,
            homeCountryOption: ibJS.application ? ibJS.application.homeCountryUs : '',
            submitted: false,
            destinationCountry: ibJS.application && ibJS.application.destinationCountries && ibJS.application.destinationCountries.length > 0 ? ibJS.application.destinationCountries[0].country : '',
            form:{
                destinationStr: [],
                hostState: ibJS.application?.appCompanyHccmis?.hostState || '',
                destInclCostaRica: getItemSessionStorage.call(this,'destInclCostaRica') !== undefined ? getItemSessionStorage.call(this,'destInclCostaRica') : '',
                groupTravelersInfo: ibJS.application ? ibJS.application.groupTravelersInfo : [],
                groupUpload: ibJS.application?.groupUpload ? ibJS.application.groupUpload : false,
                travelers: null
            },
            isStudentSecure: hccConfig.isStudentSecure(),
            isExchangeGuardGrp: hccConfig.isExchangeGuardGrp(),
            UserLoggedInMyAcoount: ibJS.UserLoggedInMyAcoount,
            hasChildfromQuote: false,
            hasSpousefromQuote: false,
            numOfChildFromQuote: 0,
            showLoginModalComponent: false,
            currentLang: window.globalLanguage.lang,
            methodOfEntry: ibJS.application && ibJS.application.groupUpload !== null ? (ibJS.application.groupUpload ? 'upload' : 'input') : '',
            fileName: ibJS.application?.groupTravelersFileName ? ibJS.application.groupTravelersFileName : '',
            allAgeGroups: [],
            wtPlanId: new WTPlanIds()  
        }
    },
    validations: function(){        
        var validations = {
            form:{
                startDate: !this.form.groupUpload ? {
                  monthDate,
                  numbersWithDashSlash,
                  noAlphabets,
                  required
                } : {},
                endDate: !this.form.groupUpload ? {
                  required,
                  monthDate,
                  numbersWithDashSlash,
                  noAlphabets,
                  isAfterStartDate: isAfterField('startDate',this.submitted)
                } : {},
                travelerInfos: !this.isExchangeGuardGrp ? {
                    $each:{
                        age: {
                            requiredChild,
                            childAge,
                            minValue: minValue(0)
                        }
                    }
                } : {},
                groupTravelersInfo: this.isExchangeGuardGrp && !this.form.groupUpload ? {
                    setGrpSize,
                    $each:{
                        ageGroup: {
                            required,
                            noDuplicateAgeGroup
                        },
                        numTravelers: {
                            required,
                            minValue: minValue(1)
                        }
                    }
                } : {},
                destInclCostaRica:{},
                hostState: { requiredIfStudentPlansAndUSA },
            },
            destinationCountry: {requiredIfStudentPlans},
            homeCountryOption:{},
            methodOfEntry: {},
            fileName: {}
        };

        if (!this.form.groupUpload) {
            this.showEndDateError = this.form.endDate === '';
        }

        function childAge(x,a){
            return a.travelerType === 'child' && x !== '' && x !== null && x > 17 && this.form.planId == wtPlanIds.VisitorSecure_Parent  ? false : true;
        }

        function spouseAge(x,a){
            if(x !== '' && x !== null) {
                return a.travelerType === 'spouse' && x < 18 && this.form.planId == wtPlanIds.VisitorSecure_Parent  ? false : true;    
            }
            return true;
        }

        var ageIndex = -1;
        function requiredChild(x,a) {
            ageIndex += 1;            
            if(this.form.planId == wtPlanIds.VisitorSecure_Parent && !this.hasChildfromQuote) {
                return this.form.travelerInfos.length > 3 && a.travelerType === 'child' && (x === '' || x === null) ? false : true;
            } else if (this.form.planId == wtPlanIds.VisitorSecure_Parent && this.hasChildfromQuote) {
                return a.travelerType === 'child' && (x === '' || x === null) ? false : true;
            } else if (this.form.planId != wtPlanIds.VisitorSecure_Parent && this.hasChildfromQuote && !this.hasSpousefromQuote && this.numOfChildFromQuote == 1 && ageIndex == 1 ) {
                /* 1 child + 0 spouse*/
                return (x === '' || x === null) ? false : true;
            } else {
                return this.form.travelerInfos.length > 3 && (x === '' || x === null) ? false : true;
            }
            
        }

        if((this.hasChildfromQuote && this.hasSpousefromQuote && this.numOfChildFromQuote >= 1)) {
            validations.form.travelerInfos.$each.age.required = required;
        }

        if(this.showHomeCountryQuestion){
            validations.homeCountryOption.required=required;
        }else{
            delete validations.homeCountryOption.required;
        }

        // if(this.isFromQuoteResults) {
        //     validations.form.travelerInfos.$each.age.spouseAge = spouseAge;
        //     validations.form.travelerInfos.$each.age.requiredChild = requiredChild;
        //     validations.form.travelerInfos.$each.age.childAge = childAge;
        // }

        if(this.hasDestCostaRica && this.form.destInclCostaRica=='') {
            validations.form.destInclCostaRica.required = required;
        } else {
            delete validations.form.destInclCostaRica.required;
        }

        if(this.isExchangeGuardGrp) {
            if(this.form.groupUpload) {
                validations.fileName.required = required;
                validations.fileName.acceptExcel = acceptExcel;
            } else {
                validations.methodOfEntry.required = required;
            }
        } else {
            delete validations.methodOfEntry.required;
            delete validations.fileName.required;
            delete validations.fileName.acceptExcel;
        }

        function acceptExcel(val) {
            let flag = true;
            if(val) {                
                flag = flag = /^([.|\w()|\s|-])*\.(?:xlsx|xls)/g.test(val);
            }
            return flag;
        }

        function setGrpSize() {
            var grpSize = 0;
            this.form.groupTravelersInfo.forEach(group => {
                if(group.numTravelers != null && group.ageGroup != null) {
                    grpSize += parseInt(group.numTravelers);
                }
            })
            return grpSize && grpSize < 5 ? false : true;
        }

        function noDuplicateAgeGroup (val, obj) {
            let noDuplicates = true;
            for (let i = 0; i < this.form.groupTravelersInfo.length; i++) {
                const thisGroup = this.form.groupTravelersInfo[i];
                if (thisGroup.ageGroup !== null) {
                    const indexOfAgeGrp = this.allAgeGroups.indexOf(+thisGroup.ageGroup);
                    if (indexOfAgeGrp != obj.index && indexOfAgeGrp > -1 && i !== indexOfAgeGrp) {
                        noDuplicates = false;
                        break;
                    }
                }
            }
            return noDuplicates;
        }

        return validations;
    },
    computed:{
        disableApplication: function(){
            if(this.homeCountryOption=='Yes'){
                return true;
            }else{
                return false;
            }
        },
        showScrollUpError: function() {
            return this.showMobileError || this.$v.form.$error || this.$v.$error || this.homeCountryOption === 'Yes';
        },
        hasDestCostaRica() {
            // if (this.destinationCountry && this.destinationCountry === 'CRI' && this.isStudentSecure) {
            //     return true;
            // }
            return false;
        },
        costaRicaRestriction() {
            if (this.hasDestCostaRica && this.form.destInclCostaRica === 'No') return true;
        },
        windowBelowSmall() {
            return window.innerWidth < 544;
        },
        disableContinue() {
            return this.formSending || this.homeCountryOption === 'Yes';
        },
        showActionButtonError() {
            return this.showScrollUpError;
        }
    },
    created: function(){
        var self = this;
        if(self.application != null){
            if(this.application.travelerInfos !== null && this.application.travelerInfos.length) {
                self.form.travelerInfos =[];
                /* only primary and spouse have age value*/
                let ageGreaterThanZero = 0;
                for(var i=0;i<self.application.travelerInfos.length;i++){
                    var newTraveler = {
                                    age: self.application.travelerInfos[i].age,
                                    tripCost: null,
                                    quotePrice:null,
                                    travelerType:self.application.travelerInfos[i].travelerType
                                };
                    self.form.travelerInfos.push(newTraveler);
                    if(self.application.travelerInfos[i] && self.form.travelerInfos[i].age==-1) {
                        this.hasChildfromQuote = true;
                        this.numOfChildFromQuote += 1;
                    }

                    if(self.application.travelerInfos[i] && self.form.travelerInfos[i].age > 0) {
                        ageGreaterThanZero += 1;
                    }
                }
                if(ageGreaterThanZero === 2) {
                    this.hasSpousefromQuote = true;
                }
            }

            if(self.form.planId==wtPlanIds.VisitorSecure_Parent && self.form.travelerInfos && Array.isArray(self.form.travelerInfos) && self.form.travelerInfos.length>1 && self.form.travelerInfos[1].travelerType!='spouse'){
                var spouse = {
                            age: null,
                            tripCost: null,
                            quotePrice:null,
                            travelerType:'spouse'
                        };
                self.form.travelerInfos.splice(1,0,spouse);
            }else if(self.form.travelerInfos && Array.isArray(self.form.travelerInfos) && self.form.travelerInfos.length==1 && !self.isMobile){
                var traveler1 = {
                            age: null,
                            tripCost: null,
                            quotePrice:null,
                            travelerType:self.form.planId==wtPlanIds.VisitorSecure_Parent?'spouse':''
                        };
                var traveler2 = {
                            age: null,
                            tripCost: null,
                            quotePrice:null,
                            travelerType:self.form.planId==wtPlanIds.VisitorSecure_Parent?'child':''
                        };
                self.form.travelerInfos.push(traveler1);
                self.form.travelerInfos.push(traveler2);
            }else if(self.form.travelerInfos && Array.isArray(self.form.travelerInfos) && self.form.travelerInfos.length==2 && !self.isMobile){
                var traveler = {
                    age: null,
                    tripCost: null,
                    quotePrice:null,
                    travelerType:self.form.planId==wtPlanIds.VisitorSecure_Parent?'child':''
                };
               self.form.travelerInfos.push(traveler);
            }

            self.travelersOpened = true;
            for(var i=0;i<self.form.travelerInfos.length;i++){
                if(self.form.travelerInfos[i].age==-1){
                    self.form.travelerInfos[i].age=null;
                    self.showTravelers=true;
                }
            }
        } else {
            removeKeySessionStorage('countryOption');
        }

        if(this.isExchangeGuardGrp) {
            if(self.application != null) {
                if(self.application.groupTravelersInfo !== null && self.application.groupTravelersInfo.length) {
                    self.form.groupTravelersInfo = [];
                    for(var i=0;i<self.application.groupTravelersInfo.length;i++){
                        var newTraveler = {
                            numTravelers: self.application.groupTravelersInfo[i].numTravelers || null
                        };
                        newTraveler.index = i;
                        if (typeof self.application.groupTravelersInfo) {
                            newTraveler.ageGroup = self.application.groupTravelersInfo[i].ageGroup == -1 ? null : self.application.groupTravelersInfo[i].ageGroup;
                        }
                        this.allAgeGroups.push(+newTraveler.ageGroup);
                        self.form.groupTravelersInfo.push(newTraveler);
                    }
                }
            } else {
                var newTraveler = {
                    ageGroup: null,
                    numTravelers: null,
                    index: 0
                }
                self.form.groupTravelersInfo.push(newTraveler);
            }
        }

        if((this.application?.planId == wtPlanIds.VisitorSecure_Parent || this.form.planId == wtPlanIds.VisitorSecure_Parent) && this.form.travelerInfos?.length) {
            if(!this.form.travelerInfos[0].travelerType) {
                this.form.travelerInfos[0].travelerType = 'primary';
            }
        }

        if(hccConfig.isStudentSecure() || hccConfig.isExchangeGuardGrp()) self.form.travelerInfos = self.form.travelerInfos.splice(0,1);
        checkExpiredAndTriggerValidation.call(this);

        $(document).ready(function () {
            $('.o-Form').on('click', function () {
                self.showTravelers = false;
            });

            $('.js-Stop-propagation').on('click', function (e) {
                e.stopPropagation();
            });
        });
    },
    mounted: function(){
        this.addInputFocusOutline();
        Vue.nextTick(() => {
            convertDateByLang(this.form, window.globalLanguage.lang);
            this.check365DayQuestion();
        });
        this.form.destinationStr = [];
        this.form.destinationStr.push(this.destinationCountry)
    },
    watch:{
        'form.startDate' : function(){
            this.removeMobileError();
            this.check365DayQuestion();
        },
        'form.endDate' : function(){
            this.removeMobileError();
            this.check365DayQuestion();
        },
        'form.travelerInfos' : function(){
            Vue.nextTick(()=>{
                this.addInputFocusOutline();
            });
        },
        destinationCountry: function () {
            this.form.destinationStr = [];
            this.form.destinationStr.push(this.destinationCountry);
            if (this.destinationCountry !== 'USA') {
                this.form.hostState = '';
            }
        },
        'form.destInclCostaRica' : function(val) {
            changeInSessionStorage.call(this,'destInclCostaRica',this.form.destInclCostaRica);

            if(val === 'No' && ibJS.affiliateValues.trawickTripCanNW) {
                window.location.href = window.qResultsLang.costaRicaLanding;
            }
        },
        'methodOfEntry' : function(val) {
            if(val === 'upload') {
                this.showEndDateError = false;
                this.form.groupUpload = true;
            } else {
                this.form.groupUpload = false;
            }
        }
    },
    methods: {
        createQuote: function (e) {
            e.preventDefault();
            var error =false;

            this.showPrimaryValidation = false;

            this.$v.$touch();

            if(this.form.travelerInfos[0]?.travelerType == 'primary' || window.ibJS.planId == '714') {
                for(var i=0;i<this.form.travelerInfos.length;i++){
                    var travelerType = this.form.travelerInfos[i].travelerType || '';   
                    if(travelerType === 'spouse' && i != 1 && this.form.travelerInfos[1].travelerType === 'spouse') {
                        travelerType = 'child';
                    }
                    this.form.travelerInfos[i].travelerType = travelerType;
                }
            } 

            if(!this.isExchangeGuardGrp) {
                if(this.form.travelerInfos?.[0]?.age === undefined || this.form.travelerInfos[0]?.age === null || this.form.travelerInfos[0]?.age === '') {
                    error=true;
                    this.showPrimaryValidation=true;
                }
                delete this.form.groupTravelersInfo;
                delete this.form.groupUpload;
                delete this.form.travelers;
            } else {
                this.form.groupTravelersInfo.forEach(insured => {
                    insured.applicationId = this.application?.id ? this.application.id : ''
                });
            }
            var quoteResultsURL='/api/'+ibJS.productName+'/quote-results/?lang='+window.globalLanguage.lang;
            if (!this.$v.$invalid && !error && !this.showEndDateError && this.homeCountryOption !== 'Yes') {
                var _this = this;

                this.spliceTravelers();

                Vue.nextTick(() => {
                    _this.hideDateError = true;
                    let langBasedData = Object.assign({}, this.form);
                    if (this.isStudentSecure) {
                        langBasedData.appCompanyHccmis = {
                            ...(langBasedData.appCompanyHccmis || {}),
                            hostState: this.form.hostState
                        };
                    }
                    createDateByLangApplications(langBasedData, window.globalLanguage.lang);
                    //Upload sheet scenario for ExchangeGuard Group plans
                    if(this.isExchangeGuardGrp && this.form.groupUpload) {
                        let data = new FormData();
                        data.append('travelers', this.form.travelers);
                        let headers = {
                            'Content-Type': 'multipart/form-data'
                        };
                        let apiUrl = '/api/'+ibJS.productName+'/upload-travelers/?lang='+window.globalLanguage.lang;
                        if(this.form.travelers != null) {
                            uploadExchangeGuardAgeGroups.call(this, apiUrl, data, headers);
                        } else {
                            delete this.form.travelers;
                            var spinTarget=this.$refs.btnspinner;
                            var spinner = new IBSpinner(ibSpinOpts).spin(spinTarget);
                            this.formSending = true;
                            window.location.href = '/'+ibJS.productName+window.qResultsLang.step1;
                        }
                    } else {
                        createUpdateApplicationService.call(this, quoteResultsURL, langBasedData, 'application');
                    }
                    this.submitted = true;
                });
                this.submitted = false;
                _this.hideDateError = false;
            }else{
                Vue.nextTick(() => goToFirstError() )
                this.showMobileError = true;
            }
        },
        check365DayQuestion: function() {
            if(this.form.startDate!='' && this.form.endDate!=''){
                let startDate = createDateByLangStr(this.form.startDate);
                let endDate = createDateByLangStr(this.form.endDate);

                if(Math.round((endDate-startDate)/(1000*60*60*24))+1 == 366 && (this.form.planId==wtPlanIds.Atlas_International||this.form.planId==wtPlanIds.Atlas_Essential_International||this.form.planId==wtPlanIds.Atlas_Premium_International || this.isStudentSecure)){
                    this.showHomeCountryQuestion = false;
                }else{
                    this.homeCountryOption='';
                }
            }
        },
        toggleTravelers: function () {
            this.showTravelers = !this.showTravelers;
            this.travelersOpened = true;
        },
        addTraveler: function() {
            var newTraveler = {
                tripCost: null,
                age: null,
                travelerType:''
            };

            var newTravelerGrp = {
                ageGroup: null,
                numTravelers: null
            }

            if(this.form.planId == wtPlanIds.VisitorSecure_Parent){
                if(this.form.travelerInfos && Array.isArray(this.form.travelerInfos) && this.form.travelerInfos.length ==1){
                    newTraveler.travelerType='spouse';
                }else if(this.form.travelerInfos && Array.isArray(this.form.travelerInfos) && this.form.travelerInfos.length>1){
                    newTraveler.travelerType='child';
                }
            }

            if(this.isExchangeGuardGrp) {
                newTravelerGrp.index = this.form.groupTravelersInfo.length;
                this.allAgeGroups.push(+this.form.groupTravelersInfo[this.form.groupTravelersInfo.length-1].ageGroup);
                this.form.groupTravelersInfo.push(newTravelerGrp);
            } else {
                this.form.travelerInfos.push(newTraveler);
            }
        },
        addSpouse: function() {
            var newTraveler = {
                tripCost: null,
                age: null,
                travelerType:'spouse'
            };
            this.form.travelerInfos.splice(1,0,newTraveler);
        },
        resetAgeValidation: function(index){
            if(!this.isExchangeGuardGrp) {
                if(this.form.travelerInfos[index] && !(/^\d+$/.test(this.form.travelerInfos[index].age))){
                    this.form.travelerInfos[index].age=null;
                }
            } else {
                if(this.form.groupTravelersInfo[index] && !(/^\d+$/.test(this.form.groupTravelersInfo[index].numTravelers))){
                    this.form.groupTravelersInfo[index].numTravelers=null;
                }
            }
            
            if(index === 0){
                this.showPrimaryValidation=false;
            }

            this.showMobileError=false;
        },
        resetForm: function(e){
            this.form.startDate='';
            this.form.endDate='';

            if(this.isMobile) {
                this.form.travelerInfos= [
                    {
                        age: null,
                        tripCost: null,
                        travelerType:''
                    }
                ];
            } else {
                this.form.travelerInfos= [
                    {
                        age: null,
                        tripCost: null,
                        travelerType:''
                    },
                    {
                        age: null,
                        tripCost: null,
                        travelerType:this.form.planId==wtPlanIds.VisitorSecure_Parent?'spouse':''
                    },
                    {
                        age: null,
                        tripCost: null,
                        travelerType:this.form.planId==wtPlanIds.VisitorSecure_Parent?'child':''
                    }
                ];
            }
            this.travelersOpened=false;
            this.formSending=false;
            this.showMobileError=false;
            this.showHomeCountryQuestion=false;
            this.homeCountryOption='';
            this.$v.$reset();
            this.$emit('resubmit');
            this.hasChildfromQuote=false;
            this.hasSpousefromQuote=false;
            this.numOfChildFromQuote=0;
            e.preventDefault();
        },
        removeMobileError: function() {
            this.showMobileError = false;
        },
        addInputFocusOutline: function(){
            //Manually add focus for trip cxl partial border inputs
            let $inputCheck=document.getElementsByClassName('input-check');
            if($inputCheck && $inputCheck.length) {
                Array.prototype.forEach.call($inputCheck,(x,i)=>{
                    let index = (i/2) >> 0;

                        x.addEventListener('focus',()=>{
                            document.getElementsByClassName('partial-border')[index]?.classList.add('multiselect-focus')
                        });
                        x.addEventListener('blur',()=>{
                            document.getElementsByClassName('partial-border')[index]?.classList.remove('multiselect-focus')
                        });

                });
            }
        },
        ageGroupUpload: function(e) {
            const file = e.target?.files?.[0];
            this.fileName = file ? file.name : '';
            this.form.travelers = file ? file : null;

            let reValidExtensions = /(\.xlsx)$/i; //only excel
            if (file?.name && !reValidExtensions.exec(file.name)) {
                this.fileTypeError = true;
            } else {
                this.fileTypeError = false;
            }
        },
        setId: function (e, value, travelIndex) {
            this.allAgeGroups[travelIndex] = +value;
        }
    }
};
